<template>
<div>
  <div class="vid">
    <iframe width="100%" height="315" src="https://www.youtube-nocookie.com/embed/L9W2c6yZAjc?rel=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
  </div>
  <div class="page light soulcraft">


      
    <div id="text">
      <div class="inner">
      <h1>Soulcraft</h1>
      <p>Copse Corner teamed up with Neil Rolfe to produce this audiovisual recording of Soulcraft playing 100% live in the studio to promote their live shows.</p>
      <!-- Check them out: <a href="http://musoalan.wixsite.com/soulcraft">Website</a>, <a href="https://en-gb.facebook.com/Soulcraft6/">Facebook</a> -->
      </div>
    </div>

  </div>
  <div class="page dark" style="min-height:100px;">
  </div>
</div>
</template>

<script>
export default {
  name: 'Soulcraft'
}
</script>

<style scoped lang="scss">
#text{
  .inner{
    max-width:1200px;
    margin: 0 auto;
  }
}
.soulcraft{
  height: auto;
  min-height: 0;

}
@media only screen and (max-width: 600px) {
.soulcraft{

}
}


</style>
